const CONCAT_API_PATH = "/cadastro/concat";
const MODAL_ACTIONS = Object.freeze({
  ADD: 1,
  EDIT: 2,
  DELETE: 3,
});

export { CONCAT_API_PATH, MODAL_ACTIONS };
